import { Download, MoreHorizontal, Share2, SlidersHorizontal } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "~/shared/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "~/shared/ui/dropdown-menu";

import { ICON_BASE } from "./chat-header-tokens";

interface ChatHeaderMenuProps {
    onExport?: () => void;
    exportDisabled?: boolean;
}

// Меню «ещё»: filter (заглушка) / download (export) / share (заглушка).
export function ChatHeaderMenu({ onExport, exportDisabled }: ChatHeaderMenuProps) {
    const { t } = useTranslation("chat");

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    className="size-9 text-zinc-500 hover:text-zinc-200"
                    aria-label={t("header.more")}
                >
                    <MoreHorizontal className={ICON_BASE} />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-44">
                <DropdownMenuItem disabled>
                    <SlidersHorizontal className="mr-2 size-4" />
                    {t("header.actions.filter")}
                </DropdownMenuItem>
                <DropdownMenuItem onSelect={onExport} disabled={!onExport || exportDisabled}>
                    <Download className="mr-2 size-4" />
                    {t("header.actions.download")}
                </DropdownMenuItem>
                <DropdownMenuItem disabled>
                    <Share2 className="mr-2 size-4" />
                    {t("header.actions.share")}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
